import gql from "graphql-tag";

export const CREATE_PROJECT = gql`
  mutation AddProject($data: ProjectDataInput) {
    addProject(data: $data) {
      id
      statuses {
        id
        createdDate
        status {
          id
          template
          name
          tag
          progress
          order
          color
          background
          moveToNext
          possibleStatuses {
            order
            nextStatus
            conditions {
              operation
              rightOperand
              leftOperand
            }
          }
          actions {
            id
            type
            args
            conditions {
              id
              operation
              rightOperand
              leftOperand
            }
          }
          process {
            id
            theme
            processStatuses {
              id
              template
              name
              tag
              progress
              order
              color
              background
              moveToNext
              createdDate
              possibleStatuses {
                order
                nextStatus
                conditions {
                  operation
                  rightOperand
                  leftOperand
                }
              }
              actions {
                id
                type
                args
                conditions {
                  id
                  operation
                  rightOperand
                  leftOperand
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_PROJECT = gql`
  mutation UpdateProject($where: ProjectWhereInput, $data: ProjectDataInput) {
    updateProject(where: $where, data: $data) {
      id
      externalId
      name
      ria
      projectType
      tracer {
        id
        name
        flow {
          process {
            config {
              type
              value
            }
          }
        }
      }
      campaign {
        id
      }
      terminationRequest {
        id
        contractNumber
        reason
        recipient
        dueDate
        terminationDate
        madeIn
        address
        complement
        zipCode
        city
        email
        brokerageMandate {
          id
          firstName
          lastName
          currentCompany
        }
      }
      statuses {
        id
        createdDate
        status {
          id
          template
          name
          tag
          progress
          order
          color
          background
          moveToNext
          createdDate
          possibleStatuses {
            order
            nextStatus
            conditions {
              operation
              rightOperand
              leftOperand
            }
          }
          actions {
            id
            type
            args
            conditions {
              id
              operation
              rightOperand
              leftOperand
            }
          }
          process {
            id
            theme
            type
            processStatuses {
              id
              name
              tag
              template
              progress
              order
              color
              background
              moveToNext
              possibleStatuses {
                id
                nextStatus
                conditions {
                  id
                  operation
                  rightOperand
                  leftOperand
                }
              }
              actions {
                id
                type
                args
                conditions {
                  id
                  operation
                  rightOperand
                  leftOperand
                }
              }
            }
          }
        }
      }
      fields
      contact {
        id
        profession
        socialRegime
        socioProfessionalCategory
        socialSecurityNumber
        exerciseFrame
        nationality
        politicallyExposedPerson
        acceptContact
        acceptContactDate
        acceptDigital
        optMadelin
        familySituation
        telecoms {
          id
          system
          value
        }
        user {
          id
          firstname
          lastname
          gender
          phone
          birthDate
        }
        relatedPersons {
          id
          relationship
          authority
          identity {
            id
            socialRegime
            socioProfessionalCategory
            socialSecurityNumber
            fields
            user {
              id
              gender
              firstname
              lastname
              birthDate
            }
          }
        }
        telecoms {
          id
          system
          value
        }
        fields
      }
      contract {
        id
        issuanceDate
        saleMode
      }
      locked
      retroactive
      expired
      subscriptions {
        id
        status
        insurancePlan {
          id
          config
        }
      }
      author {
        id
        firstname
        lastname
        email
        phone
        address
        zipCode
        city
        organization {
          id
          name
          broker {
            socialReason
            orias
            status
          }
          telecoms {
            id
            system
            value
          }
        }
      }
    }
  }
`;

export const UPDATE_PROJECT_LIGHT = gql`
  mutation UpdateProject($where: ProjectWhereInput, $data: ProjectDataInput) {
    updateProject(where: $where, data: $data) {
      id
      author {
        id
        firstname
        lastname
      }
    }
  }
`;

export const UPDATE_PROJECTS = gql`
  mutation UpdateProjects($where: ProjectWhereInput, $data: ProjectDataInput) {
    updateProjects(where: $where, data: $data) {
      id
      externalId
      name
      visible
      ria
      statuses {
        id
        createdDate
        status {
          id
          template
          name
          tag
          progress
          order
          color
          background
          moveToNext
          possibleStatuses {
            order
            nextStatus
            conditions {
              operation
              rightOperand
              leftOperand
            }
          }
          actions {
            id
            type
            args
            conditions {
              id
              operation
              rightOperand
              leftOperand
            }
          }
          process {
            id
          }
        }
      }
      fields
      contact {
        id
        socialRegime
        socioProfessionalCategory
        exerciseFrame
        acceptContact
        acceptContactDate
        acceptDigital
        telecoms {
          id
          system
          value
        }
        user {
          id
          firstname
          lastname
          gender
          phone
          birthDate
        }
        relatedPersons {
          id
          relationship
          authority
          identity {
            id
            socialRegime
            socioProfessionalCategory
            socialSecurityNumber
            fields
            user {
              id
              firstname
              lastname
              birthDate
            }
          }
        }
        telecoms {
          id
          system
          value
        }
        fields
      }
      contract {
        id
        issuanceDate
      }
      locked
      expired
      subscriptions {
        id
        status
        insurancePlan {
          id
        }
      }
      author {
        id
        firstname
        lastname
        email
        phone
        address
        zipCode
        city
        organization {
          id
          name
          broker {
            socialReason
            orias
            status
          }
          telecoms {
            id
            system
            value
          }
        }
      }
    }
  }
`;

export const DELETE_PROJECT = gql`
  mutation DeleteProject($where: ProjectWhereInput) {
    deleteProject(where: $where) {
      id
    }
  }
`;

export const DUPLICATE_PROJECT = gql`
  mutation duplicateProject(
    $where: ProjectWhereInput
    $data: ProjectDataInput
  ) {
    duplicateProject(where: $where, data: $data) {
      id
      contact {
        id
        user {
          id
        }
      }
      uid
    }
  }
`;

export const UPDATE_PROJECT_GRA = gql`
  mutation UpdateProjectGRA($where: ProjectWhereInput, $data: ProjectGRAInput) {
    updateProjectGRA(where: $where, data: $data) {
      id
      fields
    }
  }
`;

export const SYNC_PROJECT_SELLIGENT = gql`
  mutation syncProjectWithSelligent(
    $project: ProjectWhereInput
    $insurancePlan: InsurancePlanWhereInput
    $step: String
  ) {
    syncProjectWithSelligent(
      project: $project
      insurancePlan: $insurancePlan
      step: $step
    ) {
      id
      externalId
    }
  }
`;

export const SYNC_PROJECT_GUIMINI = gql`
  mutation syncProjectWithGuimini(
    $project: ProjectWhereInput
    $status: String
  ) {
    syncProjectWithGuimini(project: $project, status: $status) {
      id
      externalId
    }
  }
`;

export const EXPORT_PROJECTS = gql`
  mutation exportProjects(
    $where: ProjectWhereInput
    $gt: ProjectWhereInput
    $lt: ProjectWhereInput
  ) {
    exportProjects(where: $where, gt: $gt, lt: $lt)
  }
`;

export const SEND_PROJECTS_BY_EMAIL = gql`
  mutation sendProjectsByEmail(
    $where: ProjectWhereInput
    $gt: ProjectWhereInput
    $lt: ProjectWhereInput
  ) {
    sendProjectsByEmail(where: $where, gt: $gt, lt: $lt)
  }
`;

export const ASSIGN_PROJECT_ATTRIBUTION = gql`
  mutation AssignProjectAttribution($where: ProjectWhereInput) {
    assignProjectAttribution(where: $where) {
      id
      author {
        id
        firstname
        lastname
        email
        phone
      }
    }
  }
`;

export const NOTIFY_PROJECT_ADVISOR = gql`
  mutation NotifyProjectAdvisor($where: ProjectWhereInput) {
    notifyProjectAdvisor(where: $where)
  }
`;

const projects = {
  CREATE_PROJECT,
  UPDATE_PROJECT,
  UPDATE_PROJECTS,
  UPDATE_PROJECT_LIGHT,
  DELETE_PROJECT,
  DUPLICATE_PROJECT,
  UPDATE_PROJECT_GRA,
  SYNC_PROJECT_SELLIGENT,
  SYNC_PROJECT_GUIMINI,
  EXPORT_PROJECTS,
  SEND_PROJECTS_BY_EMAIL,
  ASSIGN_PROJECT_ATTRIBUTION,
  NOTIFY_PROJECT_ADVISOR,
};

export default projects;
